import React, { useEffect, useState } from 'react';
import { Menu, TextField, Button, Box } from '@mui/material';
export interface RangeDropdownProps {
  label: string;
  minLabel: string;
  maxLabel: string;
  updateRangeData: (value: any) => void;
  value: any;
  minDataValue?: number[] | undefined;
  maxDataValue?: number[] | undefined;
}
const RangeDropdown = ({ label, minLabel, maxLabel, updateRangeData, value, minDataValue, maxDataValue }: RangeDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [minValue, setMinValue] = useState(value?.minValue || '');
  const [maxValue, setMaxValue] = useState(value?.maxValue || '');
  const [minError, setMinError] = useState(false);
  const [maxError, setMaxError] = useState(false);
 
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
 
  const handleClose = () => {
    setAnchorEl(null);
  };
 
  const handleMinChange = (event: any) => {
    setMinValue(event?.target?.value);
  };
 
  const handleMaxChange = (event: any) => {
    setMaxValue(event?.target?.value);
  };
 
  const handleSave = () => {
    handleClose();
    updateRangeData({ minValue, maxValue })
  };
 
  const getBtnDisable = (): boolean => {
    return (minValue === "" || maxValue === "" || (minDataValue && maxDataValue && minDataValue?.length > 0 && (parseInt(minValue) < minDataValue[0] || parseInt(minValue) > maxDataValue[0])) || (maxDataValue && minDataValue && maxDataValue?.length > 0 && (parseInt(maxValue) > maxDataValue[0] || parseInt(maxValue) < minDataValue[0]))) ? true : false;
  }
 
  const open = Boolean(anchorEl);
 
  useEffect(() => {
    (minDataValue && maxDataValue && minDataValue?.length > 0 && (parseInt(minValue) < minDataValue[0] || parseInt(minValue) > maxDataValue[0])) ? setMinError(true) : setMinError(false);
    (maxDataValue && minDataValue && maxDataValue?.length > 0 && (parseInt(maxValue) > maxDataValue[0] || parseInt(maxValue) < minDataValue[0])) ? setMaxError(true) : setMaxError(false);
  }, [minValue, maxValue, maxDataValue, minDataValue])
 
  return (
    <Box>
      <Button style={{ width: "210px", color: "inherit", borderColor: "inherit", fontSize: "10px", lineHeight: '1.4375em', height: "3rem", justifyContent: 'left' }} onClick={handleClick} variant="outlined">
        {value ? `Selected ${label} : Min ${value?.minValue} Max ${value?.maxValue}` : `Select ${label}`}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Box p={2} sx={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex" }}>
            <TextField
              label={minLabel}
              value={minValue}
              onChange={handleMinChange}
              margin="normal"
              type="number"
              sx={{ width: "75%" }}
              error={minError}
              helperText={minError ? `Number Should be in between ${minDataValue} and ${maxDataValue} and not less than ${minDataValue}` : ''}
              InputProps={{
                inputProps: {
                  min: minDataValue,
                },
              }}
            />
            <TextField
              label={maxLabel}
              value={maxValue}
              onChange={handleMaxChange}
              margin="normal"
              type="number"
              sx={{ width: "75%" }}
              error={maxError}
              helperText={maxError ? `Number Should be in between ${minDataValue} and ${maxDataValue} and not greater than ${maxDataValue}` : ''}
              InputProps={{
                inputProps: {
                  max: maxDataValue,
                },
              }}
            />
          </div>
 
          <Button
            onClick={handleSave}
            variant="contained"
            color="primary"
            style={{ marginTop: '16px' }}
            disabled={getBtnDisable()}
          >
            Save Range
          </Button>
        </Box>
      </Menu>
    </Box>
  );
};
 
export default RangeDropdown;